import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  userName: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  fullName: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  email: Yup.string()
    .nullable()
    .email("Email không hợp lệ")
    .required(VALIDATE_MESSAGE.required)
});